"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberArrayToMetricStatsType = exports.wagMean = exports.confidence = exports.meanStdDevCnt = exports.count = exports.mean = exports.stdDev = void 0;
const core_services_1 = require("@iotv/core-services");
const stdDev = (values) => {
    var avg = (0, exports.mean)(values);
    var squareDiffs = values
        .filter((x) => x && x !== null)
        .map(function (x) {
        if (avg != undefined) {
            var diff = x - avg;
            var sqrDiff = diff * diff;
            return sqrDiff;
        }
        else {
            return undefined;
        }
    });
    var avgSquareSum = squareDiffs.reduce((a, b) => a + b, 0);
    var counts = squareDiffs.length;
    if (avgSquareSum != undefined && counts != 0) {
        if (counts > 1) {
            var avgSquareDiff = avgSquareSum / (counts - 1);
        }
        else {
            var avgSquareDiff = 0;
        }
    }
    else {
        var avgSquareDiff = undefined;
    }
    if (avgSquareDiff != undefined) {
        var stdDev = Math.sqrt(avgSquareDiff);
        return stdDev;
    }
    else {
        return undefined;
    }
};
exports.stdDev = stdDev;
const mean = (values) => {
    var sum = values
        .filter((x) => x && x !== null && typeof x === 'number')
        .reduce(function (sum, value, i) {
        const newSum = sum + value;
        if (isNaN(newSum)) {
            throw new Error(`NaN summed with ${value}`);
        }
        if (newSum === Infinity) {
            throw new Error(`Infinity summed from: ${value} added to ${sum} (at index ${i})`);
        }
        return newSum;
    }, 0);
    let cnt = (0, exports.count)(values);
    if (cnt > 0) {
        var avg = sum / cnt;
        return avg;
    }
    else {
        return undefined;
    }
};
exports.mean = mean;
const count = (values) => values.filter((x) => x && x !== null).length;
exports.count = count;
const meanStdDevCnt = (values) => {
    return {
        mean: (0, exports.mean)(values),
        stdDev: (0, exports.stdDev)(values),
        cnt: (0, exports.count)(values),
    };
};
exports.meanStdDevCnt = meanStdDevCnt;
const confidence = (values) => {
    const cnt = (0, exports.count)(values);
    var avg = (0, exports.mean)(values);
    var squareDiffs = values.map(function (x) {
        if ((x || x === 0) && avg != undefined) {
            var diff = x - avg;
            var sqrDiff = diff * diff;
            return sqrDiff;
        }
        else {
            return undefined;
        }
    });
    const filteredSquareDiffs = squareDiffs.filter((x) => typeof x === 'number');
    const totalSquareDiffs = filteredSquareDiffs.reduce((acc, curr) => acc + curr);
    const confidence = squareDiffs.map((sq, i) => (sq ? Math.sqrt(totalSquareDiffs / sq) : null));
    return confidence;
};
exports.confidence = confidence;
const wagMean = (values) => {
    const confidenceArr = (0, exports.confidence)(values);
    const confidenceTot = confidenceArr.reduce((acc, curr, i) => acc + (typeof curr === 'number' ? curr : 0), 0);
    const wag = confidenceTot !== 0
        ? values.reduce((acc, curr, i) => {
            const confidence = confidenceArr[i];
            return typeof curr === 'number' && typeof confidence === 'number' ? acc + curr * confidence : acc;
        }, 0) / confidenceTot
        : 0;
    return wag;
};
exports.wagMean = wagMean;
const numberArrayToMetricStatsType = ({ numNulls, period }) => {
    const nonNulls = numNulls.filter(core_services_1.existsFilter);
    const { firstTimestamp = 0, lastTimestamp = 0 } = period ?? {};
    const { cnt, mean = NaN, stdDev } = (0, exports.meanStdDevCnt)(nonNulls);
    const result = {
        count: cnt,
        max: Math.max(...nonNulls),
        min: Math.min(...nonNulls),
        mean,
        sdPop: stdDev ?? NaN,
        sdSample: stdDev ?? NaN, // TODO!!
        varPop: stdDev ? Math.pow(2, stdDev) : NaN,
        varSample: stdDev ? Math.pow(2, stdDev) : NaN,
        firstTimestamp,
        lastTimeStamp: lastTimestamp,
    };
    return result;
};
exports.numberArrayToMetricStatsType = numberArrayToMetricStatsType;
